import { render } from "./Area.vue?vue&type=template&id=2dfe98f6&scoped=true"
import script from "./Area.vue?vue&type=script&lang=js"
export * from "./Area.vue?vue&type=script&lang=js"

import "./Area.vue?vue&type=style&index=0&id=2dfe98f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dfe98f6"]])

export default __exports__